export default "__VITE_ASSET__Cn14s2iw__"